import CrudApi from './crud';

export const crud = new CrudApi('/schools/:schoolId/classes/:classId/students', { only: ['index', 'destroy'] });
